import { render, staticRenderFns } from "./PdfDownloadList.vue?vue&type=template&id=798eb257&"
import script from "./PdfDownloadList.vue?vue&type=script&lang=ts&"
export * from "./PdfDownloadList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports